var config = {};
config.portal_api_domain = Laravel.portalUrl;
config.csrf_token = Laravel.csrfToken;

window.portal = {
    user: null,
    loginActionPerformed: false,
    jwtToken: '',
    callback: function() {},

    onAuthentication(callback) {
        this.callback = callback;

        // If we've already performed the login when the developer
        // hooks into this event, we'll fire it off right away.
        if (this.loginActionPerformed) {
            this.triggerOnAuthenticationCallback()
        }
    },

    triggerOnAuthenticationCallback() {
        this.loginActionPerformed = true;

        this.callback({
            user: this.user
        });
    },

    start() {
        function receiveMessage (event) {
            if (event.origin !== config.portal_api_domain) return;

            if (! event.data.token) {
                // can't login!
                return portal.triggerOnAuthenticationCallback();
            }

            portal.receiveLoginData(event.data);
            window.removeEventListener("message", receiveMessage, false);
        }

        window.addEventListener("message", receiveMessage, false);
    },

    receiveLoginData(data) {
        this.user = data.user;

        var request = new XMLHttpRequest();
        request.open('POST', '/set-token', true);
        request.setRequestHeader('X-CSRF-TOKEN', config.csrf_token);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        request.setRequestHeader('Accept', "application/json");
        request.responseType = 'json';

        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                // Success!
                portal.triggerOnAuthenticationCallback();
                portal.jwtToken = this.response.jwtToken;
            }
            else {
                console.log('error retrieving login data');
                // We reached our target server, but it returned an error
                // console.log(this.status);
            }
        };

        // request.onerror = function() {
        //   // There was a connection error of some sort
        // };

        request.send("token=" + data.token);
    }
};

portal.start();



// WEBPACK FOOTER //
// ./resources/assets/js/authenticator.js